import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import I18n from 'I18n';
import { listMembershipFromObjectSegFilterStrict } from '../../list-membership-utils';
import { useSnowflakeJoinMetadata } from '../../../../metadata/joins-with-meta';
// @ts-expect-error untyped import
import { useTableDescription, useTableSource } from '../SourceMeta';
import { getTableLabelWithSelfJoins } from '../../../../utils/table-utils';
import { FETCH_LISTS_BY_IDS } from './fetchObjectLists';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getOperatorDisplayText = operator => {
  switch (operator) {
    case 'ListIsMember':
      return I18n.text('reporting-snowflake.filter-editor.list-membership.applied-operator-in');
    case 'ListIsNotMember':
      return I18n.text('reporting-snowflake.filter-editor.list-membership.applied-operator-not');
    default:
      return operator;
  }
};
const ListOperatorDisplayView = ({
  filter
}) => {
  var _listData$listOvervie;
  const listId = filter.getIn(['filter', 'listId']);
  const {
    data: listData
  } = useQuery(FETCH_LISTS_BY_IDS, {
    variables: {
      listIds: listId ? [Number(listId)] : []
    },
    skip: !listId
  });
  const listMembership = useMemo(() => {
    const {
      filter: listFilter
    } = filter;
    return listFilter && listFilter.get('operator') ? listMembershipFromObjectSegFilterStrict(listFilter.toJS()) : undefined;
  }, [filter]);
  const listText = I18n.text('reporting-snowflake.filter-editor.list-membership.field-name');
  const listName = (listData === null || listData === void 0 || (_listData$listOvervie = listData.listOverview) === null || _listData$listOvervie === void 0 || (_listData$listOvervie = _listData$listOvervie.edges) === null || _listData$listOvervie === void 0 || (_listData$listOvervie = _listData$listOvervie[0]) === null || _listData$listOvervie === void 0 || (_listData$listOvervie = _listData$listOvervie.node) === null || _listData$listOvervie === void 0 ? void 0 : _listData$listOvervie.name) || listText;
  const operatorText = listMembership !== null && listMembership !== void 0 && listMembership.name ? getOperatorDisplayText(listMembership.name) : '';
  return /*#__PURE__*/_jsxs(View, {
    children: [operatorText && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: operatorText
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h6",
      children: listName
    })]
  });
};
const ListFilterDisplayLabel = ({
  filter
}) => {
  const {
    field: {
      table
    }
  } = filter;
  const source = useTableSource(table);
  const tableDescription = useTableDescription();
  const {
    data: allJoinMetadata
  } = useSnowflakeJoinMetadata();
  const tableName = getTableLabelWithSelfJoins(table || '', tableDescription, source, allJoinMetadata);
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "list-filter-display-label",
    children: [/*#__PURE__*/_jsx(Text, {
      display: "block",
      as: "h6",
      children: tableName
    }), /*#__PURE__*/_jsx(ListOperatorDisplayView, {
      filter: filter
    })]
  });
};
export default ListFilterDisplayLabel;